export const urlExcludeInterceptor = [ '/admins/current', '/deployments/recents', '/permissions/presentations',
                                       '/settings', '/news', '/process'];
